import React from "react";
import leftBg from "../Images/LeftBg.jpg";
import rightBg from "../Images/RightBg.jpg";
import leftImg from "../Images/LeftImg.png";
import rightImg from "../Images/RightImg.png";
import "../NewHomeCss/HomeSection1.css";
import { useNavigate } from "react-router-dom";
import HomeText from "../components/HomeText";

const HomeSection1 = () => {
  const navigate = useNavigate();

  const handleGetStart = () => {
    sessionStorage.setItem("selectedService", "Real Estate");
    sessionStorage.setItem("selectedSubService", "India");
    sessionStorage.setItem("serviceid", 5);
    // navigate('/finalform');
    navigate("/selectrealEaste");
  };

  const handleKnowMore = () => {
    window.location.href = "https://retail.blaccdot.com/retail-leads";
  };

  return (
    <section className="homeSection1">
      {/* CENTER TITLE */}
      <div className="centerTitle">
        <h1>Supercharge Your Growth with Smart Leads</h1>
      </div>

      {/* LEFT PANEL */}
      <div className="panel" style={{ backgroundImage: `url(${leftBg})` }}>
        <div className="panelBottom">
          <div className="panelButtons">
            <button className="primaryBtn" onClick={handleGetStart}>
              Start Subscription
            </button>
          </div>
          <div className="overlayContent leftContent">
            <h2>LeadFlow Subscription</h2>
            <p style={{ marginTop: "20px" }}>
              LeadFlow Subscription ensures reliable delivery of qualified leads
              targeted by project, location, and custom criteria, with
              growth-focused subscription plans.
            </p>
          </div>
        </div>

        <img
          bounce
          src={leftImg}
          alt="Left visual"
          className="bottomImg leftImg"
        />
      </div>

      {/* RIGHT PANEL */}
      <div className="panel" style={{ backgroundImage: `url(${rightBg})` }}>
        <div className="panelBottom">
          <div className="overlayContent rightContent">
            <h2>Pay-Per-Lead</h2>
            <p style={{ marginTop: "20px" }}>
              Purchase verified leads on demand based on your exact
              requirements, ensuring cost efficiency and higher conversion
              potential.
            </p>
          </div>
          <div className="panelButtons">
            <button className="secondaryBtn" onClick={handleKnowMore}>
              Get Buyers
            </button>
          </div>
        </div>
        <img
          bounce
          src={rightImg}
          alt="Right visual"
          className="bottomImg rightImg"
        />
      </div>

      {/* CENTER BUTTONS */}
      <div className="centerButtons">
        <button className="primaryBtn" onClick={handleGetStart}>
          Start Subscription
        </button>
        <button className="secondaryBtn" onClick={handleKnowMore}>
          Get Buyers
        </button>
      </div>
    </section>
  );
};

export default HomeSection1;
